import { ValidationContext } from "../../../../common/validation/validationContext";
import { ValidationErrorLevels } from "../../../../common/validation/ValidationErrorLevels";
import { ValidationScopes } from "../../../../common/validation/ValidationScopes";
import { TplSearchArbetsorderQuery } from "../models/queries";
import { TplValidationTexts as texts } from "./tpl-validation-texts";

export class TplSearchValidation {
    static init(sok: TplSearchArbetsorderQuery): ValidationContext {
        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.sok).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                expression: () =>  sok.produktionsomradeIdList.length > 0,
                message: { text: texts.validation.mandatory },
                model: () => sok.produktionsomradeIdList,
                name: "produktionsomradeIdList"
            }
        ]);
        return context;
    }
}
